import { NgZone, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import uuid from 'uuid-random';
import { ToastMessageType } from './toast-messages.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
/**
 * Service to manage creating and removing messages displayed by ToastMessagesComponent.
 */
export class ToastMessagesServiceBase {
    constructor(sanitizer, ngZone) {
        this.sanitizer = sanitizer;
        this.ngZone = ngZone;
        this.messageTypeCss = {
            [ToastMessageType.INFO]: 'toast-black',
            [ToastMessageType.ERROR]: 'toast-error',
            [ToastMessageType.NEUTRAL]: 'toast-neutral',
            [ToastMessageType.SIGNAL]: 'toast-signal',
            [ToastMessageType.SUCCESS]: 'toast-success',
        };
        this.messages = [];
    }
    /**
     * Create a toast message that will be automatically removed in `timeout` seconds.
     * If the timeout is 0, then the message will not be automatically removed. To prevent XSS attacks, the `innerHtml`
     * is sanitized as HTML before being added to the message list.
     */
    addMessage(innerHtml, messageType = ToastMessageType.INFO, timeout = 5000, icon = '') {
        const id = uuid();
        const message = {
            id,
            innerHtml: this.sanitizer.sanitize(SecurityContext.HTML, innerHtml) || '',
            css: this.messageTypeCss[messageType],
            icon,
        };
        this.ngZone.run(() => {
            this.messages = [message, ...this.messages];
        });
        if (timeout > 0) {
            setTimeout(() => {
                this.removeMessage(id);
            }, timeout);
        }
    }
    removeMessage(id) {
        this.ngZone.run(() => {
            this.messages = this.messages.filter((message) => message.id !== id);
        });
    }
}
ToastMessagesServiceBase.ɵfac = function ToastMessagesServiceBase_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastMessagesServiceBase)(i0.ɵɵinject(i1.DomSanitizer), i0.ɵɵinject(i0.NgZone)); };
ToastMessagesServiceBase.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToastMessagesServiceBase, factory: ToastMessagesServiceBase.ɵfac });
